import { RestoreUnitModal } from '@apps-common/apps/portal/pages/units/pages/manage/pages/details/components/management'
import { ButtonRoundLg } from '@apps-common/components/elements'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'

interface IProps {
  loading?: boolean
  unit?: IUnitGenericDetailsModel
}

export const RestoreUnitButton: React.FC<IProps> = ({ loading, unit }) => (
  <ModalButton
    component={RestoreUnitModal}
    disabled={loading}
    componentProps={{ unit }}
    enterAnimation={modalSlideUpEnterAnimation}
    leaveAnimation={modalSlideUpLeaveAnimation}
    backdropDismiss
  >
    <ButtonRoundLg
      type='div'
      loading={loading}
      disabled={loading}
      className='action-warning'
      tooltip={{ id: 'unit-cancelled-restore', place: 'bottom', message: 'Restore to active' }}
    >
      <commonIcons.cancelRestore className='!text-[1.1rem]' />
    </ButtonRoundLg>
  </ModalButton>
)
